// Tema claro/escuro. Botão: [data-theme-toggle]; ícone que acompanha o estado: [data-theme-icon].
// Preferência guardada em localStorage ('one-theme'); dia é o padrão, o tema do sistema não vale.
const $ = window.jQuery;

const Theme = function () {

    const KEY = 'one-theme';

    const get = function () {
        return document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';
    };

    const set = function (mode) {
        document.documentElement.dataset.theme = mode;
        try { localStorage.setItem(KEY, mode); } catch (e) {}
        $('[data-theme-icon]').attr('class', 'ai ai-' + (mode === 'dark' ? 'sun-high' : 'crescent'));
    };

    const load = function () {
        // Telas sem tema (login): sempre dia, e a escolha guardada não é tocada.
        if ($('[data-theme-fixed]').length) {
            document.documentElement.dataset.theme = 'light';
            return;
        }
        let saved = null;
        try { saved = localStorage.getItem(KEY); } catch (e) {}
        set(saved === 'dark' ? 'dark' : 'light');
    };

    const toggle = function () {
        set(get() === 'dark' ? 'light' : 'dark');
    };

    return {
        init: function () {
            load();
            $(document).on('click', '[data-theme-toggle]', toggle);
        },
        get: get,
        set: set,
        toggle: toggle
    };
}();

module.exports = Theme;
